import PercentInput from './PercentInput';

/** Two-decimal numeric input (same behavior as PercentInput — name reflects ratio/money fields). */
export default PercentInput;
